/**
 * Bike speed conversion for backend contract.
 *
 * UI speed values (km/h): 15, 25, 45.
 * Backend expects converted values: 10, 16, 30.
 */

export const convertBikeSpeedKmhToBackend = ( speedKmh: 15 | 25 | 45 ): 10 | 16 | 30 => {
    switch ( speedKmh ) {
        case 15:
            return 10;

        case 25:
            return 16;

        case 45:
            return 30;
    }
};

